import Vue from 'vue';

export async function index(params) {
  const response = await Vue.prototype.$http.get('/local_categories', {
    params
  });
  
  return response.data;
}

export async function store(payload) {
  const response = await Vue.prototype.$http.post('/local_categories', payload);

  return response.data;
}

export async function show(id) {
  const response = await Vue.prototype.$http.get('/local_categories/' + id);

  return response.data;
}

export async function update(id, payload) {
  const response = await Vue.prototype.$http.put('/local_categories/' + id, payload);

  return response.data;
}

export async function updateImage(id, payload) {
  const response = await Vue.prototype.$http.post(`/local_categories/${id}/image`, payload);

  return response.data;
}

export async function deleteImage(id, payload) {
  const response = await Vue.prototype.$http.delete(`/local_categories/${id}/image`, payload);

  return response.data;
}

export async function destroy(id) {
  const response = await Vue.prototype.$http.delete('/local_categories/' + id);

  return response.data;
}